import { render, staticRenderFns } from "./BracketSportsmanItemDraw.vue?vue&type=template&id=96efcb9c&scoped=true&"
import script from "./BracketSportsmanItemDraw.vue?vue&type=script&lang=js&"
export * from "./BracketSportsmanItemDraw.vue?vue&type=script&lang=js&"
import style0 from "./BracketSportsmanItemDraw.vue?vue&type=style&index=0&id=96efcb9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96efcb9c",
  null
  
)

export default component.exports